import { atom } from "jotai";

export const historicoAtom = atom([]);
export const loadingAtom = atom(false);
export const anioFiltroAtom = atom(new Date().getFullYear());
export const visibleDrawerCargarAtom = atom(false);
export const filtroColaboradorAtom = atom(undefined);
export const filtroSubsidioAtom = atom(undefined);
export const detalleSeleccionadoAtom = atom(undefined);
